<app-pop-up-modal-custom
    *ngIf="modalCustom.modal$ | async as modal"
    [show]="modal.show"
    [titulo]="modal.titulo"
    [mensaje]="modal.mensaje"
    [tipo]="modal.tipo"
    [textoBoton]="modal.textoBoton"
    [textoBotonCancelar]="modal.textoBotonCancelar"
    [mostrarBoton]="modal.mostrarBoton !== false"
    [tiempoAutoCierre]="modal.tiempoAutoCierre || 0"
    [ancho]="modal.ancho"
    [variante]="modal.variante"
    (confirmado)="modalCustom.confirmar()"
    (cerrado)="modalCustom.cerrar()"
>
    <ng-container *ngTemplateOutlet="modal.contenido"></ng-container>
</app-pop-up-modal-custom>
